<template>
	<div
		class="notes-page__wrapper"
		:class="{ 'notes-page__wrapper--selected': modalIsOpen }"
		@click="handleClick"
	>
		<div class="d-flex align-center">
			<Avatar borderRadius="square" :size="52" :avatar="user.user_logo" />
			<div class="notes-page__wrapper__info ml-3">
				<span class="notes-page__wrapper__info__name">
					{{ user.visible_username }}
				</span>
				<div
					v-if="user.second_profile_row || user.third_profile_row"
					class="notes-page__wrapper__info__rows"
				>
					<span class="notes-page__wrapper__info__row">
						{{ user.second_profile_row }}
					</span>
					<span class="notes-page__wrapper__info__row">
						{{ user.third_profile_row }}
					</span>
				</div>
				<span
					v-if="user.location_profile_row"
					class="notes-page__wrapper__info__location d-flex align-center"
				>
					{{ user.location_profile_row }}
				</span>
			</div>
		</div>
		<div v-if="modalIsOpen">
			<NoteFormModal
				v-on:closeModal="handleClose"
				:show="modalIsOpen"
				:id="user.user_id"
				:username="user.visible_username"
			/>
		</div>
	</div>
</template>

<script>
import Avatar from '../Avatar'
import NoteFormModal from '../Modals/NoteFormModal.vue'

export default {
	components: {
		Avatar,
		NoteFormModal,
	},
	props: {
		user: {
			type: Object,
			default: () => ({}),
		},
		selectedUser: {
			type: Number,
			default: null,
		},
	},
	methods: {
		handleClick() {
			this.$emit('selectUser', this.user.user_id)
		},
		handleClose() {
			this.$emit('selectUser', null)
		},
	},
	computed: {
		modalIsOpen() {
			return this.selectedUser === this.user.user_id
		},
	},
}
</script>

<style lang="scss">
.notes-page {
	&__wrapper {
		display: flex;
		gap: 8px;
		font-family: 'Inter', sans-serif;
		justify-content: space-between;
		align-items: center;
		padding: 12px;
		border: 1px solid #e2e2e2;
		border-radius: 8px;
		background-color: #ffffff;
		margin-bottom: 8px;
		cursor: pointer;
		&:hover,
		&--selected {
			border: 1.5px solid var(--vote_bar_tint);
			box-shadow: 0 0 0 2px #0055a333;
		}
		&__info {
			display: flex;
			flex-direction: column;
			&__rows {
				display: flex;
				flex-direction: column;
				gap: 2px;
			}
			&__name {
				font-weight: 700;
				font-size: 16px;
				line-height: 100%;
				letter-spacing: 0;
				color: var(--username-category-title);
				margin-bottom: 4px;
			}
			&__row {
				font-weight: 400;
				font-size: 13px;
				line-height: 100%;
				letter-spacing: 0;
				color: var(--company-position-large);
			}
			&__location {
				margin-top: 8px;
				font-weight: 500;
				font-size: 13px;
				line-height: 100%;
				letter-spacing: 0;
				color: var(--location-color);
			}
		}
	}
}
</style>
